import { Box } from "@mui/material";
import { useEffect } from "react";
import { Datagrid, EditButton, FunctionField, List, ReferenceField, ShowButton, TextField, useStore } from "react-admin";
import { CityEnum, CityIdMapping } from "../../enums/CityEnum";
import { useAppSelector } from "../../store/hooks";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
    { type: "text", label: "Search by phone", source: "mobile" },
    {
        type: "select",
        label: "City",
        source: "cityId",
        options: Object.values(CityEnum).map((key) => ({
            value: CityIdMapping[key],
            label: key,
        })),
    },
    { type: "text", label: "Search by Id", source: "id" },
];

const HouseList = (props: any) => {
    const isCustomSelectOpen = useAppSelector((state) => state.customSelect.value.open);
    const [, setUserBundlesForHouse] = useStore<boolean>('customerTabs_housesForCustomer', false)
    useEffect(() => setUserBundlesForHouse(false))
    return (
        <List
            {...props}
            sx={{
                "& .RaList-content": {
                    boxShadow: "none",
                    backgroundColor: "transparent",
                },
            }}
        >
            <>
            <CommonFilterCard fields={filterFields} />

            <br />

            <StyledDatagridWrapper title="Houses">
            <Datagrid bulkActionButtons={false} sx={commonDatagridSx} rowStyle={(record, index) => {
                return {
                    backgroundColor:
                    record.hasActiveSubscription ? "#ADD8E3" : "",
                    color: record.hasActiveSubscription ? "#ffffff" : "",
                };
                }}>
                {/*Will be active if custom popup is open*/}
                {
                    isCustomSelectOpen?
                    <ResourceSelectDialogButton />: <ShowButton  />
                }

                <TextField source="id" sortable={false} />
                <TextField source="hasActiveSubscription" label='Active Subscription' sortable={false} />
                <FunctionField
                    emptyText=""
                    label="Address"

                    render={(record: any) =>
                        <Box
                            title={record?.fullAddress || ""}
                            sx={{
                                minWidth: "200px",
                                maxWidth: "320px",
                                // wrap onto max two lines instead of one long row
                                whiteSpace: "normal",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                            }}
                        >
                            {record?.fullAddress || "-"}
                        </Box>
                    }
                />
                {/* <FunctionField label="address" render={(record: any) => <Box minWidth="200px">{record?.address}</Box>} /> */}
                <TextField source="locality" sortable={false} />
                <ReferenceField source="cityId" link="show" reference="Cities">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="areaId" link="show" reference="Areas">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField source="localityId" link="show" reference="Localities">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="mobile" sortable={false} />
                <TextField source="sector" sortable={false} />
                <TextField source="lat" sortable={false} />
                <TextField source="long" sortable={false} />
                <EditButton />
                {/*Fields which will be not shown when custom popup is open goes here*/}
            </Datagrid>
            </StyledDatagridWrapper>
            </>
        </List>
    )
};

export default HouseList;
